"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initialState = {
    filterItemsState: {
        userItemState: {
            type: "user",
            filterEnabled: false,
            selectedUser: ""
        },
        acceptanceStatusItemState: {
            type: "acceptance-status",
            filterEnabled: false,
            selectedStatus: []
        }
    },
    searchSelections: {
        userItemState: {
            type: "user",
            filterEnabled: false,
            selectedUser: ""
        },
        acceptanceStatusItemState: {
            type: "acceptance-status",
            filterEnabled: false,
            selectedStatus: []
        }
    },
    showResults: false
};
function reducer(state = initialState, action) {
    const type = action.type;
    switch (type) {
        case "t-and-c-acceptance-status/SET_FILTER_ITEMS_STATE":
            // Handle the action and update the state accordingly
            return Object.assign(Object.assign({}, state), { filterItemsState: action.filterItemsState });
        case "t-and-c-acceptance-status/SHOW_RESULT": {
            return Object.assign(Object.assign({}, state), { showResults: true, searchSelections: {
                    userItemState: {
                        type: "user",
                        filterEnabled: state.filterItemsState.userItemState.filterEnabled,
                        selectedUser: state.filterItemsState.userItemState.filterEnabled
                            ? state.filterItemsState.userItemState.selectedUser
                            : ""
                    },
                    acceptanceStatusItemState: {
                        type: "acceptance-status",
                        filterEnabled: state.filterItemsState.acceptanceStatusItemState.filterEnabled,
                        selectedStatus: state.filterItemsState.acceptanceStatusItemState
                            .filterEnabled
                            ? state.filterItemsState.acceptanceStatusItemState.selectedStatus
                            : []
                    }
                } });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(type);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map